import { Constant, SimpleHeaders } from "../apiConstants";

const GetPwaToken = async (custID, bankName) => {
  const endpoint = Constant.GET_TOKEN;
  const BaseUrl = Constant.TOKEN;
  try {
    const response = await fetch(BaseUrl + "/" + endpoint, {
      method: "post",
      headers: SimpleHeaders,
      body: JSON.stringify({
        chegCustomerId: custID,
        bankName: bankName
      }),
    });
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default GetPwaToken;
